import { render, staticRenderFns } from "./AssignmentTypeSelect.vue?vue&type=template&id=187020c5&"
import script from "./AssignmentTypeSelect.vue?vue&type=script&lang=js&"
export * from "./AssignmentTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports